// import update from "immutability-helper";
import {
  SET_NODES,
  SET_EDGES,
  UPDATE_NODES,
  UPDATE_EDGES,
  SET_NODE_MODAL,
  MODIFY_NODE,
  SET_IS_ON_CONNECTION,
  SET_WINDOWS_LIST,
  SET_VARIABLES_PAYLOAD,
  SET_FORMULA_FIELD_DATA,
  SET_VARIABLE_FIELDS,
  SET_RESOURCES_LIST,
  UPDATE_RESOURCES_LIST,
  SET_WINDOW_FIELDS,
  SET_LAYOUT_FIELDS,
  CLEAR_RESOURCES_LIST,
  UPDATE_NODE_MODAL,
  SET_ARRAY_OBJECT_FIELDS,
  SET_LOOKUP_DETAILS,
  UPDATE_LOOKUP_DETAILS,
  UPDATE_LOOKUP_DETAILS_MULTI,
  SET_INPUT_VARIABLES,
  SET_FORMULA_FIELD_DETAILS,
  SET_ACTION_ELEMENTS_DETAILS,
  SET_ACTION_API_DATA,
  CLEAR_ACTION_API_DATA,
  SET_ASSIGNMENT_ARRAY_FIELD_DETAILS,
  SET_DIRECTORY_FIELD_DETAILS,
  SET_OUTPUT_FIELDS,
  SET_HOVER_CONNECTION_LINE
} from "../actionTypes/RatingsFlowActionTypes";
import {lookupFieldDataFromGroups} from "../../Containers/StepsFlowContainer/StepsFunction";
import { isSet } from "../../Utils/CommonFunctions";
// import {getQueryVariable} from '../../Utils/CommonFunctions';

const initialState = {
  nodes:[],
  edges:[],
  isOnConnection:false,
  nodePayload:{
    type:'Assignment'
  },
  lookupFieldsData:{},
  isLookupFieldPopup:false,
  formulaFieldData:{},
  formulaFieldPopup:false,
  windowsList:[],
  windowFields:{},
  arrayObjectFields:{},
  layoutFields:{},
  variableFields:[],
  formulaFieldsData:{},
  resourcesList:{
    constants:[],
    variables:[],
    resources:[]
  },
  inputValuesPayload:[],
  isModalOpen:false,
  actionElementsDetails:[],
  actionApiData:{},
  assignmentArrayFieldPopup:false,
  assignmentArrayFields:{},
  currentAssignmentArrayFields:{},
  directoryFieldData:{},
  directoryFieldPopup:false,
  outputFields:{},
  // hoveringEdge:null,
  // isHoverEdge:false
};

const RatingsFlowReducer = (state = initialState, action) => {
  const {nodes,edges,resourcesList,windowFields,layoutFields,nodePayload,arrayObjectFields,lookupFieldsData,actionApiData,outputFields} = state;
  const {payload,type} = action;
  let updatedState = null;let updateNodes = null;let updateEdges = null,updateResourcesList=null
  let winId = null,apiKey=null,sectionId=null;

  switch (type) {
    case SET_WINDOWS_LIST:
      return{
        ...state,
        windowsList:[...payload]
      }
    case SET_INPUT_VARIABLES:
      return{
        ...state,
        inputValuesPayload:payload
      }
    case SET_WINDOW_FIELDS:
        const {winFields} = payload;
        winId = payload.winId;
        updatedState = {
          ...windowFields,
          [winId]:winFields
        }
        return{
          ...state,
          windowFields:updatedState
        } 
    case SET_LAYOUT_FIELDS:
      const {laytFields} = payload;
      winId = payload.winId;
      updatedState = {
        ...layoutFields,
        [winId]:laytFields
      }
      return{
        ...state,
        layoutFields:updatedState
      }
    case SET_HOVER_CONNECTION_LINE:
      let updateEdgesForAnimate = edges.map((item)=>{
        return{
            ...item,
            animated: (item.id===payload.edgeId)?false:true,
        }
    })
      return{
        ...state,
        edges:updateEdgesForAnimate,
        // hoveringEdge:payload.edgeId,
        // isHoverEdge:!state.isHoverEdge
      }
    case SET_OUTPUT_FIELDS:
        const {outputFieldPayload} = payload;
        const tId = payload.tId;
        // console.log('outputFields1',tId,outputFields);
        
        updatedState = {
          ...outputFields,
          [tId]:outputFieldPayload
        }
        return{
          ...state,
          outputFields:updatedState
        }
    case SET_ARRAY_OBJECT_FIELDS:
      const {varId,fields} = payload;
      updatedState = {
        ...arrayObjectFields,
        [varId]:fields
      }
      return{
        ...state,
        arrayObjectFields:updatedState
      }
    case SET_ACTION_API_DATA:
      const apiData = payload.apiData;
      const param_value = payload.paramValue;
      const param_value_all = payload.paramValueAll;
      const isArrayData = payload.isArrayData;
      apiKey  = payload.apiKey;

      // let datas = {}
      let datasNew = {}
      //console.log('param_value===',param_value,actionApiData[apiKey])
      //console.log('updatedState000==',updatedState)
      if(param_value!=='' && isArrayData===true){
        // datas = {
        //   ...isSet(isSet(actionApiData[apiKey],{[apiKey]:{datas:{}}})).datas,
        //   [param_value]:(apiData===undefined)?[]:apiData
        // }
        



        if(isArrayData===true && isSet(actionApiData[apiKey],null)!==null){          
          if(isSet(param_value_all,[]).length>0){
            param_value_all.forEach((val)=>{
              //console.log('actionApiData[apiKey].datas[val]',actionApiData[apiKey].datas)
              let varArrData = actionApiData[apiKey].datas[val];
              if(param_value===val){
                varArrData = apiData;
              }
              datasNew={
                ...datasNew,
                [val]:(varArrData===undefined)?[]:varArrData
              }
            })  
          }

        }
      }

      //console.log('param_value_all===',param_value_all)
      //console.log('param_value===',datas)
      //console.log('param_value datasNew===',datasNew)
      //console.log('updatedState1111==')
      updatedState = {
        ...actionApiData,
        [apiKey]:{
          data:apiData,
          datas:datasNew,
          id:payload.apiUrl,
          payload:payload.apiPayLoad,
          lookup_data:payload.lookupData,
          is_array_data:isArrayData,
          param_all:param_value_all
        }
      }
      //console.log('updatedState==',updatedState)
      return{
        ...state,
        actionApiData:updatedState
      }
    case CLEAR_ACTION_API_DATA:
      return{
        ...state,
        actionApiData:{}
      }  
    case SET_VARIABLE_FIELDS:
        return{
            ...state,
            variableFields:payload
          }
    case SET_FORMULA_FIELD_DATA:
          return{
            ...state,
            formulaFieldsData:payload
          } 
    case UPDATE_RESOURCES_LIST:
      const {resourceKey,resourceValue} = payload;
      updateResourcesList = {
        ...resourcesList,
        [resourceKey]:resourceValue
      }
      return{
        ...state,
        resourcesList:updateResourcesList
      }
    case CLEAR_RESOURCES_LIST:
      return{
        ...state,
        resourcesList:{
          constants:[],
          variables:[],
          resources:[]
        }
      }  
      case SET_RESOURCES_LIST:
        updateResourcesList = {
          ...resourcesList,
          ...payload
        }
        return{
          ...state,
          resourcesList:updateResourcesList
        }          
    case SET_IS_ON_CONNECTION:
      return{
        ...state,
        isOnConnection:payload.bool
      }
    case SET_VARIABLES_PAYLOAD:
        return{
          ...state,
          variablesPayload:payload
      }   
    case SET_NODES:
      updateNodes = [...payload];
      return{
        ...state,
        nodes:updateNodes
      }
    case SET_EDGES:
      updateEdges = [...payload];
      return{
        ...state,
        edges:updateEdges
      }  
    case UPDATE_NODES:
      updateNodes = [...nodes,payload];
      return{
        ...state,
        nodes:updateNodes,
        nodePayload:payload,
        isModalOpen:true
      }  
    
    case UPDATE_EDGES:
      updateEdges = [...edges,payload];
        return{
          ...state,
          edges:updateEdges
        }  
    case SET_NODE_MODAL:
      const {dataObj,isModalOpen} = payload;
      return{
        ...state,
        nodePayload:dataObj,
        actionApiData:{},
        isModalOpen:isModalOpen
      } 
    case UPDATE_NODE_MODAL:
      const {updateDataObj} = payload;
      let updateNodeModal = {
        ...nodePayload,
        data:updateDataObj
      }
      return{
        ...state,
        nodePayload:updateNodeModal
      }  
    case MODIFY_NODE:
        const {nodeId, nodeData} = payload;
         updateNodes = [...nodes].map((node)=>{
          let updateNode = {...node};
          if(node.id===nodeId){
            updateNode = nodeData;
          }
          return updateNode
        })
        return{
          ...state,
          nodes:updateNodes,
          // isModalOpen:false
        }
    case SET_FORMULA_FIELD_DETAILS:
      return{
        ...state,
        formulaFieldData:payload.fieldObj,
        formulaFieldPopup:payload.bool,
      }
    case SET_ASSIGNMENT_ARRAY_FIELD_DETAILS:
      return{
        ...state,
        assignmentArrayFields:payload.fieldObj,
        assignmentArrayFieldPopup:payload.bool,
        currentAssignmentArrayFields:payload.currentData
      }
    case SET_LOOKUP_DETAILS:
      return{
        ...state,
        lookupFieldsData:lookupFieldDataFromGroups(payload.lookupFieldsData),
        isLookupFieldPopup:payload.bool,
      }
    case UPDATE_LOOKUP_DETAILS:
      const {valueObj} = payload;
      apiKey = payload.apiKey;
      // console.log('payload',payload);
      let updateLookupFieldsData = {
        ...lookupFieldsData,
        valuesObject:{
          ...lookupFieldsData.valuesObject,
          [apiKey]:valueObj
        }
      }
      //console.log('updateLookupFieldsData',updateLookupFieldsData);
    return{
      ...state,
      lookupFieldsData:updateLookupFieldsData
    }
    case UPDATE_LOOKUP_DETAILS_MULTI:
      const {valueObjMulti,subformRowIndex} = payload;
      sectionId = payload.sectionId;
      apiKey = payload.apiKey;
      // console.log('payload',payload);
      let updateSection = isSet(lookupFieldsData.valuesObject[sectionId],[]);
      // updateSection.findIndex((i)=>)
      const indexing = updateSection.findIndex((i,inx)=> inx===subformRowIndex);
      if(indexing===-1){
        updateSection.push({
          [apiKey]:valueObjMulti
        })
      }
      //console.log('updatedSection111',updateSection)
      let updatedSection = [...updateSection.map((itm,itmIndex)=>{
        //console.log('itmIndex-subformRowIndex',itmIndex,subformRowIndex,itm)
            let returnDat = {
              ...itm
            }
            if(itmIndex===subformRowIndex){
              returnDat = {
                ...returnDat,
                [apiKey]:valueObjMulti
              }
            }
            return returnDat;
      })];
      let updateLookupFieldsDataMulti = {
        ...lookupFieldsData,
        valuesObject:{
          ...lookupFieldsData.valuesObject,
          [sectionId]:updatedSection                               
        }
      }
      //console.log('updateLookupFieldsDataMulti',valueObjMulti);
    return{
      ...state,
      lookupFieldsData:updateLookupFieldsDataMulti
    }  
    case SET_ACTION_ELEMENTS_DETAILS:
      return{
        ...state,
        actionElementsDetails:[
          // ...actionElementsDetails,
          ...isSet(payload,[])
        ]
      }
    case SET_DIRECTORY_FIELD_DETAILS:
      //console.log('SET_DIRECTORY_FIELD_DETAILS',payload.bool)
      return{
        ...state,
        directoryFieldData:payload.fieldObj,
        directoryFieldPopup:payload.bool,
      }
    default:
      return state;
  }
};

export default  RatingsFlowReducer